import { NavLink } from "react-router-dom";
import Sebbe from "../images/hero2.webp";
import routeUrls from "../COMPONENTS/navbar/navLink";
import { usePageBackground } from "../COMPONENTS/usePageBackground";
import "../CSS/about.scss";

export const AboutMePageView = ({ handleOnClick }: { handleOnClick?: () => void }) => {
  usePageBackground();
  return (
    <div className="about">
      <div className="about__inner">
        <div className="about__text">
          <NavLink to={routeUrls.HOME} className="about__back">← Hem</NavLink>
          <h1 className="about__title">Om mig</h1>
          <p>
            Most of my free time is spent outdoors. I’m pretty big on skiing—whether it’s XC or
            downhill—and I’m usually out on a bike or running when the snow is gone. I enjoy the mix
            of road and mountain biking, and I’m generally just a fan of staying active and testing
            myself a bit.
          </p>
          <p>
            Beyond sports, I really love traveling and exploring new places. I’ve always got some
            kind of project on the go, and I’m usually looking for the next thing to learn or a new
            sport to try out.
          </p>
          <ul className="about__links">
            <li><a href="mailto:sgran@kth.se">sgran@kth.se</a></li>
            <li><a href="https://www.linkedin.com/in/sebastian-granlund-6a7a8ab1/">LinkedIn</a></li>
            <li><a href="tel:+46732688883">+46 732 68 88 83</a></li>
          </ul>
        </div>
        <img className="about__photo" src={Sebbe} alt="Sebastian på skidor" />
      </div>
    </div>
  );
};
